import React from 'react';
export const VideoInterior: React.FC = () => {
  return <section className="py-7 px-4 bg-cream" data-id="element-247">
      <div className="max-w-3xl mx-auto" data-id="element-248">
        <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-violet text-center leading-tight mb-2" data-id="element-249">
          Así se ve por <span className="text-gold-dark" data-id="element-250">dentro</span>
        </h2>
        <p className="text-center text-textsoft mb-6 text-base font-semibold" data-id="element-251">
          Todo organizado para que encuentres tus personajes favoritos
          fácilmente.
        </p>

        <div className="relative rounded-3xl overflow-hidden border-[6px] border-violet shadow-2xl bg-violet" data-id="element-252">
          <video src="https://cdn.shopify.com/videos/c/o/v/7d086146e6674195996d1cae5067fb5b.mov" autoPlay muted loop playsInline controls={false} className="w-full h-full object-cover" data-id="element-253" />
        </div>
      </div>
    </section>;
};